import { ProjectsCreateDialog } from '@/components/dialogs/projects/create'
import { useUserQuery } from '@/hooks/user/use-user-query'

export const NewProjectAction = () => {
  const { data: user } = useUserQuery()

  if (!user.is_admin && !user.is_root) {
    return null
  }

  return <ProjectsCreateDialog />
}
